// frontend/src/router/routes/areasRoutes.tsx
// NEW: Dedicated Areas Routes - Following bookingRoutes.tsx pattern

import { Route } from "react-router-dom";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import ProviderAreasManagement from "@/pages/ProviderAreasManagement";
import AreaFormPage from "@/components/areas/AreaFormPage";

export const areasRoutes = [
  // =====================================
  // 🗺️ UNIFIED AREAS ROUTES - ROLE-BASED LAYOUT DETECTION
  // These routes work for both ADMIN and PROVIDER with automatic layout detection
  // CRITICAL: Specific routes MUST come BEFORE general routes
  // =====================================
  
  // Add new area form (providers only) - MUST BE FIRST
  <Route
    key="provider-areas-add"
    path="/provider-areas/add"
    element={
      <ProtectedRoute requiredRoles={["provider"]}>
        <AreaFormPage />
      </ProtectedRoute>
    }
  />,

  // Edit area form (providers only)
  <Route
    key="provider-areas-edit"
    path="/provider-areas/edit/:id"
    element={
      <ProtectedRoute requiredRoles={["provider"]}>
        <AreaFormPage />
      </ProtectedRoute>
    }
  />,

  // View area (admin and providers)
  <Route
    key="provider-areas-view"
    path="/provider-areas/view/:id"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <AreaFormPage />
      </ProtectedRoute>
    }
  />,

  // Main provider areas route - automatically detects admin vs provider layout
  // MUST BE AFTER specific routes
  <Route
    key="provider-areas"
    path="/provider-areas"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <ProviderAreasManagement />
      </ProtectedRoute>
    }
  />,

  // Legacy compatibility routes (if any exist)
  <Route
    key="areas-management"
    path="/areas"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <ProviderAreasManagement />
      </ProtectedRoute>
    }
  />,
];

// NOTE: The layout (admin vs provider) is automatically determined in ProviderAreasManagement
// based on the user's role. No need to pass layout prop explicitly.